<template lang="html">
  <div>
    <vs-card>
			<div slot="header">
				<vs-row>
					<vs-col vs-w='9'>
						<h3>{{$t('Translations')}}</h3>
					</vs-col>
					<vs-col vs-w='3'>
						<vs-button class='float-right' @click.prevent='form.show=true'>Create</vs-button>
					</vs-col>
				</vs-row>
			</div>
    </vs-card>
    
    <vs-table search max-items="10" pagination :data="languages">
      
      <template slot="thead">
				<vs-th sort-key='id'>#</vs-th>
				<vs-th sort-key='title'>{{ $t('Language') }}</vs-th>
				<vs-th sort-key='code'>{{ $t('LanguageCode') }}</vs-th>
        <vs-th class="testing" >{{ $t("Actions") }}</vs-th>
      </template>

      <template slot-scope="{data}">
          <vs-tr :key="language.id" v-for="language in data">

            <vs-td>{{ language.id }}</vs-td>
            <vs-td>{{ language.title }}</vs-td>
            <vs-td>{{ language.code }}</vs-td>
            <vs-td>
              <router-link
                class="mb-2 mr-1"
                :to="`language/${language.code}/edit`"
              >
                <vs-button class="" color="primary" type="filled">{{$t('Edit')}}</vs-button>
              </router-link>
            </vs-td>
          </vs-tr>
      </template>
    </vs-table>

    <vs-prompt :acceptText="$t('Save')" @accept='create()' :cancelText="$t('Cancel')" :title="$t('Create')"  :active.sync="form.show" :isValid='isCreateFormValid'>
      <vs-input :dangerText="errors.first('language_name')" :danger="errors.has('language_name')" @blur="$validator.validate('language_name')" class='mb-2 w-full' v-validate="'required'" label='Name' type="text" v-model='form.title' name='language_name' />
      <vs-input :dangerText="errors.first('language_code')" :danger="errors.has('language_code')" @blur="$validator.validate('language_code')" class='mb-2 w-full' v-validate="'required|min:2'" label='Code' type="text" v-model='form.code' name='language_code' />
      <vs-checkbox v-model="form.isFallback">Fallback?</vs-checkbox>
      
      <vs-alert color="rgb(231, 154, 23)" active="true" class="mt-5 text-warning">
        <p class="mb-1 event-msg">
          <b>{{$t('Note')}}:</b> {{$t('LanguageFallbackSettingNote')}}
        </p>
      </vs-alert>
    </vs-prompt>
  </div>
</template>

<script>
import { getLanguages, createLanguage } from '../../../api/locale'
export default {
  data: () => ({
    languages: [],
    addNewFormModal: false,
    form: {
      show: false,
      code: '', 
      title: '',
      description: null,
      isFallback: false,
      get isValid() {
        return this.title.length > 0 && this.code.length > 0
      }
    }
  }),
  computed: {
    isCreateFormValid() {
      return this.form.isValid && !this.errors.has('language_title') && !this.errors.has('language_code') 
    }
  },
  mounted() {
    this.getAll()
  },
  methods: {
    async getAll() {
      this.$vs.loading()
      try{
        const res = await getLanguages();
        if(res.status==200 && res.data.status=='success') {
          this.languages = res.data.data;
        }else
          throw res.data.message
      }catch(err){
        this.$vs.notify({
          title: $t('Error'),
          text: err,
          color: 'danger',
          position: "top-center"
        });
				this.$log.error('File : languages/List.vue | Function : getAll() | Error :', err);
        console.error(err);
      }
      this.$vs.loading.close();
    },

    async create() {
      const valid = await this.$validator.validate();
      if(!valid)
        return false;
      this.$vs.loading();
      try{
        const payload = {...this.form};
        payload.isFallback = Number(this.form.isFallback);
        const res = await createLanguage(payload);
        if(res.status==200 && res.data.status=='success') {
          this.getAll();
          this.form = { ...this.form, title: '', code: ''};
        }else
          throw res.data.message
      }catch(err){
        this.$vs.notify({
          title: this.$t('Error'),
          text: err,
          color: 'danger',
          position: "top-center"
        });
				this.$log.error('File : languages/List.vue | Function : create() | Error :', err);
        console.error(err);
      }
      this.$vs.loading.close();
    }
  }
}
</script>